export default {"src":"/_next/static/media/facebook.33eeaead.svg","height":24,"width":12};